import SidebarMenu from './SidebarMenu';
import sidebarShape from '../../assets/images/M_cut.png';

const Sidebar = () => {
  return (
    <aside
      className="
      fixed
    top-[90px]
    left-0
    w-[260px]
    h-[calc(100vh-90px)]
    gradient-border
    shadow-committeeCard
    overflow-hidden
    flex
    flex-col
    justify-between
    bg-gradient-to-b
    from-[#16364B]
    to-[#102A3C]
    px-5
    py-8
    z-40
  "
    >
      {/* Top Content */}
      <div className="relative z-10">
        <h4 className="text-sm text-[#7FA0B4] mb-5">Governance</h4>

        <SidebarMenu />
      </div>

      {/* Decorative Image */}
      <div className="mb-20 mt-20">
        <img
          src={sidebarShape}
          alt=""
          className="
          absolute
          bottom-16
          left-1/2
          -translate-x-1/2
          w-[250px]
          opacity-20
          pointer-events-none
          select-none
        "
        />
      </div>

      {/* Collapse Button */}
      {/* <button
        className="
          relative
          z-10
          flex
          items-center
          gap-2
          text-gray-300
          text-sm
          hover:text-white
        "
      >
        <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center">←</div>
        Collapse
      </button> */}
    </aside>
  );
};

export default Sidebar;
